<template>
    <div style="height:100vh;display:flex;flex-direction:column;">
        <div style="position:fixed;top:0;left:0;right:0;background:#F7F8FA;height:56px;border-bottom:1px solid #EBEDF0;z-index:999;display:flex;align-items:center;padding:0 12px;">
            <!-- 返回按钮 -->
            <div @click="onClickLeft" style="width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;">
                <van-icon name="arrow-left" size="18" color="#333333" style="font-weight:600;" />
            </div>
            
            <!-- 搜索框 -->
            <div style="flex:1;margin:0 12px;">
                <div style="background:#FFFFFF;border-radius:15px;border:1px solid #E5E5E5;height:30px;display:flex;align-items:center;padding:0 12px;">
                    <van-icon name="search" size="14" color="#999999" style="margin-right:6px;" />
                    <input 
                        v-model="v_search" 
                        placeholder="搜索维修用户/产品编码/产品名称/客户"
                        style="border:none;outline:none;background:transparent;flex:1;font-size:13px;color:#333333;height:100%;"
                    />
                </div>
            </div>
            
            <!-- 右侧按钮组 -->
            <div style="display:flex;gap:8px;align-items:center;flex-shrink:0;">
                <div @click="onSearch" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
                    <van-icon name="search" size="14" color="#1ECD84" />
                </div>
                <div @click="addRec" :class="addBool?'icon-disabled':''" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
                    <van-icon name="plus" size="14" :color="addBool?'#AAAAAA':'#235EFF'" />
                </div>
            </div>
        </div>
        <van-loading type="spinner" color="#235EFF" style="z-index:100;width:100%;text-align:center;padding:40px 0;" v-if="v_loading"/> 
        <div style="flex:1;overflow-y:auto;background:#F7F8FA;padding: 12px;margin-top:56px;padding-bottom:60px;">
            <div v-for="(item,index) in tabData" :key="index" style="margin-bottom:12px;">
                <van-text-box type="5">
                    <template>
                        <van-divider dashed style="margin:8px 0;" />
                        <van-row type="flex" justify="end" style="gap:8px;padding:0 8px;">
                            <van-button size="small" style="background:#235EFF;color:#FFFFFF;border:none;height:28px;padding:0 10px;font-size:12px;border-radius:6px;" @click="editRec(item,'N')">
                                <i class="iconfont icon-chakan2" style="font-size:12px;color:#FFFFFF;margin-right:2px;"></i>查看                                
                            </van-button>
                            <van-button :disabled="editBool" size="small" style="background:#1ECD84;color:#FFFFFF;border:none;height:28px;padding:0 10px;font-size:12px;border-radius:6px;" @click="editRec(item,'E')">
                                <i class="iconfont icon-bianji" style="font-size:12px;color:#FFFFFF;margin-right:2px;"></i>编辑
                            </van-button>
                            <van-button :disabled="delBool" @click="stfgRec(item,index)" size="small" style="background:#FF4000;color:#FFFFFF;border:none;height:28px;padding:0 10px;font-size:12px;border-radius:6px;">
                                <i class="iconfont icon-shanchu1" style="font-size:12px;color:#FFFFFF;margin-right:2px;"></i>作废
                            </van-button>
                        </van-row>
                    </template>
                    <div slot="content">
                        <div style="color:#333333;font-size:14px;font-weight:600;line-height:22px;">{{item['SALENO']}}</div>
                        <div style="color:#235EFF;font-size:14px;font-weight:500;line-height:22px;margin-top:4px;">{{item['SUBIDNO']}}</div>
                        <div style="color:#333333;font-size:14px;font-weight:500;line-height:22px;margin-top:4px;">产品名称：{{item['MATDESC']}}</div>
                        <div style="color:#666666;font-size:12px;line-height:20px;margin-top:6px;">{{item['SUBUSER']}}</div>
                    </div>
                    <div slot="tip">
                        <div style="color:#333333;font-size:14px;font-weight:500;line-height:22px;">品名：{{item['MATNM']}}【{{item['MATNO']}}】</div>
                    </div>
                    <div slot="cover">
                        <van-image @click="preview(item.IMGPATH)" :src="item.IMGPATH" fit="fill" style="width:50px;height:50px;margin-right:10px;border-radius:4px;" />
                    </div>
                </van-text-box>
            </div>
        </div> 
        <div style="border-top:1px solid #EBEDF0;background:#FFFFFF;position:fixed;bottom:0;left:0;right:0;z-index:100;">
            <van-pagination v-model="currentPage" :total-items="v_total" :items-per-page="rowSize" :show-page-size="5" force-ellipses @change="changePage">
                <template #prev-text>
                    <van-icon name="arrow-left" />
                </template>
                <template #next-text>
                    <van-icon name="arrow" />
                </template>
                <template #page="{ text }">{{ text }}</template>
            </van-pagination>
        </div>
        <!-- 新增---编辑窗口 -->
        <van-popup v-model="editWin" :close-on-click-overlay="false" round :style="{ height: '94%', width: '98%' }">
          <div style="background:#F7F8FA;height:36px;display:flex;align-items:center;justify-content:space-between;padding:0 16px;border-bottom:1px solid #EBEDF0;">
            <van-button @click="editWin=false" size="small" style="background:#AAAAAA;color:#FFFFFF;border:none;height:30px;padding:0 16px;font-size:14px;border-radius:8px;">
              <van-icon name="cross" size="14" style="margin-right:4px;" />关闭
            </van-button>
            <van-button :disabled="v_commit" v-if="v_flag=='Y'||v_flag=='E'" @click="saveRec" size="small" style="background:#235EFF;color:#FFFFFF;border:none;height:30px;padding:0 16px;font-size:14px;border-radius:8px;">
              <van-icon name="success" size="14" style="margin-right:4px;" />保存记录
            </van-button>
          </div>
            <div style="overflow-y:auto;height:calc(100% - 56px);background:#F7F8FA;padding:12px;">             
                <div class="section-header">
                    <div class="section-title">产品信息</div>      
                    <div v-if="v_flag=='Y'" @click="selOrd" style="cursor:pointer;">
                        <van-icon name="plus" size="20" color="#235EFF" />
                    </div>   
                </div>
                <div class="info-card">
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">销售订单：</div>
                            <div class="info-value">{{v_formRow['REFIDNO']}}</div>
                        </div>
                        <div class="info-item">
                            <div class="info-label">产品编码：</div>
                            <div class="info-value">{{v_formRow['MATNO']}}</div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">客户名称：</div>
                            <div class="info-value">{{v_formRow['CLNTNM']}}</div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item full-width">
                            <div class="info-label">产品名称：</div>
                            <div class="info-value">{{v_formRow['MATNM']}}</div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">订单数量：</div>
                            <div class="info-value">{{v_formRow['QTY']}}</div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">规格型号：</div>
                            <div class="info-value">{{v_formRow['MATDESC']}}</div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">维修人员：</div>
                            <div class="info-value">{{v_formRow['ADDUSER']}}</div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">维修日期：</div>
                            <div class="info-value">{{v_formRow['ADDDTTM']}}</div>
                        </div>
                    </div>
                </div>
                
                <div class="section-header">
                    <div class="section-title">维修明细</div>
                    <div v-if="v_flag=='Y'" @click="dtlAdd" style="cursor:pointer;">
                        <van-icon name="plus" size="20" color="#235EFF" />
                    </div>                         
                </div>
                <div style="min-height:100px;">
                    <div v-for="(item,index) in dtlData" :key="index" class="form-item" style="display: flex">
                        <div style="flex:1;">
                            <div class="form-row">
                                <div class="form-label"><span class="required">*</span>不良现象:</div>
                                <select v-model="item['BADNM']" style="flex:1;height:32px;border:1px solid #D9D9D9;border-radius:4px;padding:0 8px;font-size:13px;">
                                    <option v-for="(opt,idx) in badArr" :key="idx" :value="opt.CNAME">{{ opt.CNAME }}</option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="form-label"><span class="required">*</span>故障诊断:</div>
                                <input v-model="item['FIXNM']" style="flex:1;height:32px;border:1px solid #D9D9D9;border-radius:4px;padding:0 8px;font-size:13px;" />
                            </div>
                            <div class="form-row">
                                <div class="form-label"><span class="required">*</span>故障物料:</div>
                                <input v-model="item['REASON']" style="flex:1;height:32px;border:1px solid #D9D9D9;border-radius:4px;padding:0 8px;font-size:13px;" />
                            </div>
                            <div class="form-row">
                                <div class="form-label"><span class="required">*</span>线路位置:</div>
                                <input v-model="item['POSITION']" style="flex:1;height:32px;border:1px solid #D9D9D9;border-radius:4px;padding:0 8px;font-size:13px;" />
                            </div>
                            <div class="form-row">
                                <div class="form-label"><span class="required">*</span>不良数量:</div>
                                <input type="number" v-model="item['QTY']" style="flex:1;height:32px;border:1px solid #D9D9D9;border-radius:4px;padding:0 8px;font-size:13px;" />
                            </div>
                            <div class="form-row">
                                <div class="form-label">备注原因:</div>
                                <input v-model="item['RMK']" style="flex:1;height:32px;border:1px solid #D9D9D9;border-radius:4px;padding:0 8px;font-size:13px;" />
                            </div>
                        </div>
                        <div v-if="v_flag=='Y'" @click="delRec(item,index)" style="width: 20px;cursor:pointer;padding-left: 10px;padding-top: -10px">
                          <van-icon name="cross" size="16" color="#FF4000" />
                        </div>
                    </div>
                </div>

                <div class="section-header">
                    <div class="section-title">图片明细</div>
                </div>
                <div class="upload-btn-wrapper" v-if="v_flag=='Y'">
                    <input id="frfile" type="file" accept="image/*" multiple class="upload-input" @change="selFolder">
                    <div class="upload-btn">
                        <van-icon name="photograph" size="20" style="margin-right:6px;" />
                        不良维修拍照
                    </div>
                </div>
                <div v-if="v_flag=='Y'" class="image-grid">
                    <div v-for="(item,index) in imgData" :key="index" class="image-item">
                        <div style="position:relative;">
                            <van-image @click="preview(item)" :src="item" fit="cover" class="image-preview" />
                            <div @click="clearImg(index)" class="delete-icon-btn">
                                <van-icon name="delete-o" size="20" color="#FF4000" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="v_flag!=='Y'" class="image-grid">
                    <div v-for="(item,index) in phoData" :key="index" class="image-item">
                        <van-image @click="preview(item['OUTPATH'])" :src="item['OUTPATH']" fit="cover" class="image-preview" />
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 返回顶部 -->
        <div class="go_top_btn" v-show="topShow" @click="goTop">
            <van-icon name="arrow-up" size="26rem" color="#ff6700" />
        </div>
        <van-action-sheet v-model="v_ordWin"  >
            <div style="background:#F7F8FA;padding:12px;border-bottom:1px solid #EBEDF0;">
                <div style="display:flex;align-items:center;gap:8px;">
                    <div style="flex:1;">
                        <div style="background:#FFFFFF;border-radius:15px;border:1px solid #E5E5E5;height:30px;display:flex;align-items:center;padding:0 12px;">
                            <van-icon name="search" size="14" color="#999999" style="margin-right:6px;flex-shrink:0;" />
                            <input 
                                v-model="v_cond" 
                                placeholder="请输入客户名称/产品名称，可模糊查找"
                                style="border:none;outline:none;background:transparent;flex:1;font-size:13px;color:#333333;line-height:30px;"
                            />
                        </div>
                    </div>
                    <div @click="queryOrd" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
                        <van-icon name="search" size="14" color="#1ECD84" />
                    </div>
                    <div @click="v_ordWin=false" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
                        <van-icon name="cross" size="14" color="#FF4000" />
                    </div>
                </div>
            </div>
            <div style="height:80vh;overflow:auto;width:100%">           
                <div v-for="(item,index) in ordArr" :key="index" @click="selRec(item)" style="line-height:30px;height:33px;font-size:12px; border-bottom:1px solid #f7f8f9;display:flex;background:white; ">
                    <div style="width:160px; margin-left:6px;margin-top:6px" class="mul-div">{{item['CLNTNM']}}</div>
                    <div style="width:90px; margin-left:6px;margin-top:6px; " class="mul-div">{{item['IDNO']}}</div>
                    <div style="width:250px; margin-left:6px;margin-top:6px; " class="mul-div">{{item['MATNM']}}</div>
                    <div style="width:90px; margin-left:6px;margin-top:6px; " class="mul-div">{{item['MATNO']}}</div>
                </div>
            </div>
        </van-action-sheet>
        <van-action-sheet v-model="v_select"  >
            <div style="height:45px;line-height:45px;font-size:14px;font-weight:600;text-align:center" class="face"> 
                <i class= "iconfont icon-paizhao-xianxing" style="font-size:20px;margin-right:5px"></i>相机拍照
                <input  id="frphoto" type="file" accept="image/*" capture="user" class="upload" @change="selPhoto">  
            </div> 
            <div style="height:45px;line-height:45px;font-size:14px;font-weight:600;text-align:center;border-top:1px solid #ccc" class="face">
                <i class="iconfont icon-select-file"></i> 图库选择
                <input  id="frfile" type="file" accept="image/*" multiple  class="upload" @change="selFolder">  
            </div> 
        </van-action-sheet>
        <van-dialog
            v-model ="v_confirm"
            title="作废提示"
            message="你确认要作废此条记录吗？"
            show-cancel-button
            @confirm="handleConfirm"
            @cancel="handleCancel"
        />
    </div>
</template>

<script>
 
import {getDate,formateDay,getRecNum} from '@/api/tools'
 import { ImagePreview } from 'vant-green' 
export default {
    name: "fix_record",
    data() {
        return {
            v_confirm:false,
            v_commit:false,
            v_select:false,
            imgData:[],
            v_formRow:{},
            ordArr:[],
            v_ordWin:false,
            v_loading:false,
            v_search:'',
            v_cond:'',
            phoData:[],
            minDate:new Date(2024,1,1),
            editWin:false,
            currentPage: 1,
            scroll: 0,
            topShow: false,
            v_username :this.$cookies.get('v_telno' ), //用户名称 
            v_corpid:this.$cookies.get('v_corpid' ),
            v_usernm :this.$cookies.get('v_usernm' ), //用户名称 
            v_title:'',
            v_flag:'N',
            dtlData:[],
            txtparam:'',
            addBool:false,
            editBool:false,
            selWin:false,
            tabData:[],
            tabCol:[],
            allData:[],
            v_total:0,
            rowSize:22,
            delBool:false,
            mainRow:{},
            showCalendar:false,
            v_key:'',
            v_row:{},
            v_index:'',    
            badArr:[],
            v_idseq:this.$cookies.get('idseq'),
        }
    },
    components: {
 
    },
    mounted() { 
        //窗口滚动
        window.addEventListener("scroll", this.windowScroll)
        if (this.$cookies.get('v_telno' )){
            this.getTabList('')
            this.getTabField()  //窗口字段
            this.initData() //初始化一些数据
 
        }else{
            this.$router.push({path:'/login'})
        }
    },
    computed: {
        //  upperCode:{
        //     get(){
        //         return this.v_code
        //     },
        //     set(val){
        //         this.v_code =val.toUpperCase() 
        //     }
        // } ,
    },
    methods: {
        handleCancel () {
            console.log('取消删除')
        },
        stfgRec(item,index){
            if (item['ADDUSER'] ==this.v_usernm ){
                this.v_confirm =true
                this.v_row = JSON.parse(JSON.stringify(item))
                this.v_index =index
            }else{
                this.$dialog.alert({ title: '提示', message:'此记录不是本人记录，不能作废', theme: 'round-button',})
            }
        },
        handleConfirm(){
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.v_row['IDSEQ'],p_table:'qc_fix',p_cond:' set stfg=\'X\''},
            }).then(res=>{ 
                this.tabData.splice(this.v_index,1)
            })
        },
        //拍照
        selPhoto() {
            let _this = this;
            let file = document.getElementById("frphoto").files[0];
            let content = null;
            let readfile = new FileReader() //读取客户端上的文件 ,图片  长宽比例 4：3最佳
            if (file != undefined) {
                content = readfile.readAsDataURL(file, "UTF-8");
                readfile.onload = function(event) {
                    _this.dealImage(event.target.result,800,function(base64){    
                        _this.imgData.push(base64)
                
                    })
                }
            }
            this.v_select =false
        },
        //选择图片
        selFolder() {
            let _this = this;
            let files = document.getElementById("frfile").files
            files.forEach(file =>{
            let content = null;
            let readfile = new FileReader() //读取客户端上的文件 ,图片  长宽比例 4：3最佳
            if (file != undefined) {
                content = readfile.readAsDataURL(file, "UTF-8");
                readfile.onload = function(event) {
                    _this.dealImage(event.target.result,800,function(base64){    
                        _this.imgData.push(base64)
                    
                    })
                }
            }
            })
        },
        //压缩图片
        dealImage(base64, w, callback) {
			var newImage = new Image();
			var quality = 0.8;    //压缩系数0-1之间
			newImage.src = base64;
			newImage.setAttribute("crossOrigin", 'Anonymous');	//url为外域时需要
			var imgWidth, imgHeight;
			newImage.onload = function () {
				imgWidth = this.width;
				imgHeight = this.height;
				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");
				if (Math.max(imgWidth, imgHeight) > w) {
					if (imgWidth > imgHeight) {
						canvas.width = w;
						canvas.height = w * imgHeight / imgWidth;
					} else {
						canvas.height = w;
						canvas.width = w * imgWidth / imgHeight;
					}
				} else {
					canvas.width = imgWidth;
					canvas.height = imgHeight;
					quality = 0.8;
				}
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
				var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
				callback(base64);//必须通过回调函数返回，否则无法及时拿到该值
			}
		},
        //清除图片
        clearImg(index){
            this.imgData.splice(index,1)
        },
        preview(path){
            ImagePreview({
                images: [path],
                closeable: true,
            })
        } ,
        queryOrd(){
            let v_cond=' and (clntnm like \'%'+this.v_cond+'%\' or matno like \'%'+this.v_cond+'%\' or matnm like \'%'+this.v_cond+'%\' )'
            this.ordArr =[]
            this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'V_ORDITM_H5' ,p_cond:v_cond+' and rownum <60 ',p_key:'corpid',p_value:this.v_corpid},
            }).then(res=>{
                this.ordArr =res.result
            })        
        },
        onSearch(){
            let v_cond=' and (clntnm like \'%'+this.v_search+'%\' or matno like \'%'+this.v_search+'%\' or matnm like \'%'+this.v_search+'%\' or adduser like \'%'+this.v_search+'%\' )'
            this.getTabList(v_cond)
        },
        delRec(item,index){
            this.dtlData.splice(index,1)
        },
        onConfirm(date){
            this.mainRow[this.v_key]=formateDay(date)
            this.showCalendar=false
        },
        dtlAdd(){
            //-- 不良现象 BADNM ，故障诊断 FIXNM，引起故障物料 REASON ，线路板位置 POSITION 
            this.dtlData.push({LSTSEQ:'',QTY:'',RMK:'',BADNM:'',FIXNM:'',REASON:'',POSITION:''})
        },
        //选择制单
        selOrd(){
            this.v_ordWin=true     
        },
        saveRec(){
            if (!this.v_formRow['MATNO']){
                this.$dialog.alert({ title: '提示', message:'产品编码不能为空', theme: 'round-button',})
            }else if (this.dtlData.length ==0){
                this.$dialog.alert({ title: '提示', message:'请增加维修明细', theme: 'round-button',})
            }else{
                //console.log(JSON.stringify(this.dtlData))
                let v_bool =false ,v_prompt=''
                //不良现象 BADNM ，故障诊断 FIXNM，引起故障物料 REASON ，线路板位置 POSITION 
                this.dtlData.some(item=>{
                    if (!item['BADNM']){
                        v_bool =true
                        v_prompt ='明细记录的不良现象不能为空'
                    }else if (!item['FIXNM']){
                        v_bool =true
                        v_prompt ='明细记录的故障诊断不能为空'
                    }else if (!item['REASON']){
                        v_bool =true
                        v_prompt ='明细记录的引起故障物料不能为空'
                    }else if (!item['POSITION']){
                        v_bool =true
                        v_prompt ='明细记录的线路板位置不能为空'
                    }else if (!item['QTY']){
                        v_bool =true
                        v_prompt ='明细记录的不良数量不能为空'
                    }
                })
                if (v_bool){
                    this.$dialog.alert({ title: '提示', message:v_prompt , theme: 'round-button',})
                }else {
                    this.v_commit =true
                    this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.v_formRow,{CORPID:this.v_corpid })), p_table:'qc_fix',frmid:'419689'},
                    }).then(res=>{ 
                    if(res.code ==='200')  {  
                        let v_idseq =res.idseq  
                        //1、明细保存：批量保存   
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'qc_fixDTL',p_idseq:v_idseq , p_action:'S' },
                        }).then(res=>{
                            // 保存图片到服务器上   
                                if (this.v_flag =='Y'){                             
                                    this.imgData.forEach((item,index) =>{
                                        let v_file  =this.v_username+'_'+ v_idseq+'-' +index+ ".jpg"
                                        this.$axios({  //传入 路径 +文件名
                                            method: 'post',
                                            // 该页面的图片接口仍由旧 OSS 路由提供；请求实例会统一携带认证 Cookie。
                                            url: 'oss/upPhoneImg',
                                            data: {upfile:item, code:'//qcmgt//'+ v_file},
                                        }).then(res=>{
                                            if (res.code=='200'){
                                                // 1. 图片保存
                                                let v_obj ={'IDSEQ':v_idseq,LSTSEQ:'','FILETY':'FIX','FILEPATH':'/a5img/qcmgt/'+v_file }
                                                this.$axios({
                                                    method: 'post',
                                                    url:'xuper_auth/tableBodySave',
                                                    data: {p_json:JSON.stringify(v_obj), p_table:'mat_img',p_idseq:v_idseq},
                                                }) 
                                            }else{
                                                this.$dialog.alert({ title: '提示', message:res.result , theme: 'round-button',})
                                            }
                                        })
                                    
                                    }) 
                                }
                                this.v_commit =false
                                this.editWin =false
                                this.getTabList('')
                                this.$toast({type:'html',icon:'smile-o',message:'已保存成功',size:'large',duration:'3000'}) 
                        })
                    }else{
                        this.$dialog.alert({ title: '提示', message:res.result , theme: 'round-button',})
                        this.v_commit =false
                    } 
                    })
                }
            }
        },
        //获取权限
        getPriv(){
            this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'v_sys_user_priv' ,p_key:'frmidseq',p_value:'419824' ,p_key2:'userno',p_value2: this.v_username},
            }).then(res=>{
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                } 
            }) 
        },
 
        //页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
        //下拉框 选择记录
        selRec(item ){
            this.v_formRow =Object.assign(this.v_formRow,{REFIDNO:item['REFIDNO'],CLNTNM:item['CLNTNM'],MATNO:item['MATNO'],MATNM:item['MATNM'],MATDESC:item['MATDESC'],QTY:item['QTY']})
            this.v_ordWin =false
        },
        //新增
        addRec(){
            if (!this.addBool){
                this.editWin =true
                this.v_formRow ={IDSEQ:'',STFG:'N',DTTM:getDate('day'),ADDUSER:this.v_usernm,ADDDTTM:getDate('full')}
                this.v_flag ='Y'
                this.imgData=[]
                this.dtlData=[]
            }
        },
        editRec(item,val){
            this.editWin =true
            this.v_formRow =JSON.parse(JSON.stringify(item))
            this.v_flag = val
            this.getDtlList(item.IDSEQ)
        },
        //返回
        onClickLeft(){
            this.$router.push({ 
                path: '/features' ,//url指的是跳转的路径名，需要在router里面配置
            })
        },   
        getDtlList(v_idseq) { 
            this.dtlData =[]
            this.imgData=[]
            this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'V_qc_fixdtl' ,p_cond: ' order by adddttm ',p_key:'idseq',p_value:v_idseq},
            }).then(res=>{
                this.dtlData  =res.result               
            })
            this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'v_mat_img' ,p_cond: ' order by adddttm ',p_key:'idseq',p_value:v_idseq},
            }).then(res=>{
                this.phoData  =res.result               
            })
        }, 
        //初始化
        initData(){
            this.$axios({  //p_key:'idseq',p_value:v_seq,
                method: 'post',
                url:  'xuper_auth/getBaseData',
                data: {p_key:'isqry',p_value:'M',p_key2:'frmurl' ,p_value2:this.$route.query.path,p_table:'V_Sys_form' },
            }).then(res=>{
                if (res.result.length>0){
                    this.v_title =res.result[0]['CFRMNM']
        
                }else{
                    this.$dialog.alert({ title: '提示', message: '没有找到记录'+ res.result, theme: 'round-button',}) 
                }
            })
            this.getPriv()
            // 初始化订单  
            this.$axios({
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'v_sys_base' , p_cond:' and parentno=\'467733\'  '},
            }).then(res=>{
                this.badArr =res.result
            }) 
            this.$axios({
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'V_ORDITM_H5' ,p_key:'corpid',p_value:this.v_corpid ,p_cond:' and rownum<30  '},
            }).then(res=>{
                this.ordArr =res.result
            }) 
        },
        //明细查询
        getTabList(cond_) { 
            this.tabData =[]
            this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'V_qc_fix' ,p_cond:cond_ +' order by adddttm desc',p_key:'corpid',p_value:this.v_corpid},
            }).then(res=>{
                if (res.code=='200'){
                    this.allData  =res.result
                    this.initPage()
                } 
            })
        },
        initPage(){
            this.v_total =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        windowScroll() {
            this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
            this.scroll > 300 ? (this.topShow = true) : (this.topShow = false);
        },
        //返回顶部
        goTop() {
            let timer = setInterval(function() {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5);
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                this.topShow = false
                if (osTop === 0) {
                    clearInterval(timer);
                }
            }, 30)
        },
        //获取表列字段
        getTabField(){
            this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: { p_table:'v_sys_form_fld' ,p_key:'idseq',p_value:'419689',p_key2:'lstseq',p_value2:'1',p_cond:' order by sortby '},
            }).then(res=>{
                res.result.forEach(item=>{
                    this.tabCol.push({ // 
                        title: item.title,
                        key: item.key,
                        notnull:item.NOTNULL,
                        edcss: item.EDCSS,
                        thide: item.THIDE,
                        fhide: item.FHIDE,
                        disabled:item.DISABLED,
                        holder:item.HOLDER
                    })
                })               
    
            })
        } 
    },
  
};
</script>
<style lang="scss" scoped>
.go_top_btn {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding-top: 6px;
  background-color: #FFFFFF;
  border-radius: 50%;
  border: 1px solid #DCDCDC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: fixed;
  right: 20px;
  bottom: 80px;
  cursor: pointer;
  z-index: 99;
  * {
    cursor: pointer;
  }
}

.div_gray {
  color: #AAAAAA !important;
}

.div_primary {
  color: #235EFF !important;
}

.mul-div {
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.div_ellip {
  text-align: left;
  width: calc(100% - 70px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.rounded-corner {
  border-radius: 8px;
  background-color: #FFFFFF;
  padding: 16px;
  margin: 8px;
  min-height: 165px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.div-corner {
  border-radius: 8px;
  background-color: #FFFFFF;
  padding: 12px;
  margin: 8px;
  min-height: 95px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.imgcss {
  width: 100%;
  height: 100px;
  margin-left: 5px;
  margin-right: 5px;
}

.face {
  position: relative;
  .upload {
    width: calc(100% - 10px);
    height: 48px;
    line-height: 48px;
    opacity: 0;
    position: absolute;
    z-index: 22;
    left: 0;
    margin: auto;
    right: 0;
  }
  .span-txt {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #FFFFFF;
    position: absolute;
    left: 0;
    margin: auto;
    right: 0;
    background: #235EFF;
    width: calc(100% - 10px);
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    text-align: center;
    transition: all 0.3s;
    
    &:active {
      background: #103B9A;
    }
  }
}

.scan {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  .scan-box {
    width: 100%;
  }
  .close-scan {
    position: absolute;
    top: 20px;
    right: 20px;
    svg {
      width: 40px;
      height: 40px;
    }
  }
}

.one-div {
  display: flex;
  align-items: center;
  padding: 12px 8px;
  background: #F7F8FA;
  margin-top: 8px;
  
  .oneRow {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: #333333;
  }
}

::v-deep .van-search {
  padding: 0;
  
  .van-search__content {
    background: #FFFFFF;
    border-radius: 15px;
    border: 1px solid #E5E5E5;
    height: 30px;
    padding-left: 8px;
    
    &--round {
      border-radius: 15px;
    }
  }
  
  .van-field__left-icon {
    margin-right: 4px;
  }
  
  input {
    font-size: 13px;
    line-height: 30px;
    color: #333333;
    height: 30px;
    
    &::placeholder {
      color: #999999;
      font-size: 13px;
    }
  }
}

.icon-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  
  .section-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: #333333;
  }
}

.info-card {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  
  .info-row {
    display: flex;
    margin-bottom: 12px;
    flex-wrap: nowrap;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .info-item {
    flex: 1;
    display: flex;
    font-size: 13px;
    line-height: 22px;
    min-width: 0;
    
    &.full-width {
      flex: 1 1 100%;
    }
    
    .info-label {
      color: #333333;
      font-weight: 500;
      min-width: 80px;
      flex-shrink: 0;
      white-space: nowrap;
    }
    
    .info-value {
      color: #666666;
      flex: 1;
      word-wrap: break-word;
      word-break: break-all;
    }
  }
}

.form-item {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  .form-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .form-label {
      color: #333333;
      font-size: 13px;
      font-weight: 500;
      min-width: 90px;
      flex-shrink: 0;
      
      .required {
        color: #FF4000;
        margin-right: 2px;
      }
    }
    
    input, select {
      flex: 1;
      height: 32px;
      border: 1px solid #D9D9D9;
      border-radius: 4px;
      padding: 0 8px;
      font-size: 13px;
      color: #333333;
      
      &:focus {
        border-color: #235EFF;
        outline: none;
      }
    }
  }
}

.upload-btn-wrapper {
  position: relative;
  margin-bottom: 16px;
  
  .upload-input {
    width: 100%;
    height: 48px;
    opacity: 0;
    position: absolute;
    z-index: 2;
    cursor: pointer;
  }
  
  .upload-btn {
    width: 100%;
    height: 48px;
    background: #235EFF;
    color: #FFFFFF;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    
    &:active {
      background: #103B9A;
    }
  }
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 12px;
  
  .image-item {
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    
    .image-preview {
      width: 100%;
      height: 120px;
      display: block;
      border-radius: 8px 8px 0 0;
    }
    
    .image-delete-wrapper {
      padding: 8px;
      
      .delete-image-btn {
        background: #FF4000;
        color: #FFFFFF;
        border: none;
        height: 32px;
        font-size: 12px;
        border-radius: 6px;
        
        &:active {
          background: #CC3300;
        }
      }
    }
  }
}

::v-deep .van-button {
  &--small {
    height: 32px;
    padding: 0 12px;
    font-size: 12px;
    border-radius: 6px;
  }
  
  &--disabled {
    background: #AAAAAA !important;
    opacity: 0.6;
  }
}

::v-deep .van-search {
  padding: 12px 16px;
  
  .van-search__content {
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #D9D9D9;
    
    &--round {
      border-radius: 8px;
    }
  }
  
  input {
    font-size: 14px;
    line-height: 22px;
    color: #333333;
    
    &::placeholder {
      color: #999999;
    }
  }
}

::v-deep .van-text-box {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 12px;
  padding-bottom: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

::v-deep .van-pagination {
  padding: 12px 0;
  background: #FFFFFF;
  
  .van-pagination__item {
    border-radius: 8px;
    color: #666666;
    font-size: 14px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    
    &--active {
      background: #235EFF;
      color: #FFFFFF;
    }
  }
}
</style>
<style lang="less">
.van-pagination__item {
  border-radius: 8px;
  color: #666666;
}
</style> 
